import { fg } from '@atlassian/jira-feature-gating';
import getMeta from '@atlassian/jira-get-meta';

export const isSynthetic = (): boolean =>
	getMeta('ajs-is-synthetic') === 'true' || fg('is_synthetic_tenant');
